// extracted by mini-css-extract-plugin
export default {"action-button":"IqGX_S","actionButton":"IqGX_S"};